module.exports = __webpack_public_path__ + "img/ev-logo-round.87a042e5.png";